import React, { useMemo } from "react";
import DiscountCode from "../DiscountCode/DiscountCode";
import SummaryHeader from "../SummaryHeader/SummaryHeader";
import SummaryList from "../SummaryList/SummaryList";
import TotalsSection from "../TotalsSection/TotalsSection";
import LegalFooter from "../LegalFooter/LegalFooter";
import MainButton from "../../Elements/MainButton/MainButton";
import basketIcon from "../../../assets/cart/cart-primary.png";
import "../CheckoutPanel/CheckoutPanel.css";

const OrderSummary = ({
  packages,
  currency,
  totals,
  items,
  orderLoading,
  speedConfirmed,
  onSpeedConfirmChange,
  newsletterOptIn,
  onNewsletterOptInChange,
  onPlaceOrder,
  onApplyPromocode,
  promocodeData,
  isGuest = false,
  hidePromocode,
  showNewsletterCheckbox,
  onNewsletterOptInGuestChange,
  promocodeError = "",
}) => {
  const isUnlimited = useMemo(() => {
    return items.some((item) => {
      const pkg = packages.find((p) => String(p.id) === String(item.internal_package_id || item.id));
      return pkg?.gigabytes === -1;
    });
  }, [items, packages]);

  return (
    <div className="checkout__left">
      <h3 className="checkout__title">
        <img className="checkout__title-icon" src={basketIcon} alt="" />
        Order Summary
      </h3>

      <SummaryHeader />
      <SummaryList items={items} packages={packages} currency={currency} />

      {!isGuest && !hidePromocode && (
        <DiscountCode onApply={onApplyPromocode} promocodeData={promocodeData} promocodeError={promocodeError} />
      )}

      <TotalsSection
        totals={totals}
        currency={currency}
        packages={packages}
        items={items}
        promocodeData={promocodeData}
      />

      <LegalFooter
        isGuest={isGuest}
        newsletterOptIn={newsletterOptIn}
        onNewsletterOptInChange={onNewsletterOptInChange}
        speedConfirmed={speedConfirmed}
        showNewsletterCheckbox={showNewsletterCheckbox}
        onSpeedConfirmChange={onSpeedConfirmChange}
        isUnlimited={isUnlimited}
        onNewsletterOptInGuestChange={onNewsletterOptInGuestChange}
      />

      <div className="summary-cta">
        <MainButton
          type="button"
          className="auth-submit auth-submit--guest"
          onClick={onPlaceOrder}
          loading={orderLoading}
          disabled={orderLoading || items.length === 0 || (speedConfirmed === false && isUnlimited)}
        >
          {orderLoading ? "Creating Secure Payment..." : "Place Order"}
        </MainButton>
      </div>
    </div>
  );
};

export default OrderSummary;
